
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.97 2.47a.75.75 0 01.53-.22H21a.75.75 0 01.75.75v7.5a.75.75 0 01-.22.53l-12 12a.75.75 0 01-1.06 0l-7.5-7.5a.75.75 0 010-1.06l12-12zm.84 1.28L2.56 15 9 21.44l11.25-11.25V3.75h-6.44z","fill":"#2F6BF0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17.25 6a.75.75 0 100 1.5.75.75 0 000-1.5zM15 6.75a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z","fill":"#2F6BF0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23.03.97a.75.75 0 010 1.06l-4.5 4.5a.75.75 0 11-1.06-1.06l4.5-4.5a.75.75 0 011.06 0zM13.28 7.72a.75.75 0 010 1.06l-6 6a.75.75 0 01-1.06-1.06l6-6a.75.75 0 011.06 0zM16.28 10.72a.75.75 0 010 1.06l-3 3a.75.75 0 11-1.06-1.06l3-3a.75.75 0 011.06 0z","fill":"#2F6BF0"}})])
          )
        }
      }
    